import { render, staticRenderFns } from "./Imports.vue?vue&type=template&id=38131e29&scoped=true&lang=pug&"
import script from "./Imports.vue?vue&type=script&lang=coffee&"
export * from "./Imports.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38131e29",
  null
  
)

export default component.exports